const __WEBPACK_NAMESPACE_OBJECT__ = ng.forms.signals.compat;